import * as types from '../../../actions';
import {LIST_TYPE,ADD_TYPE,UPDATE_TYPE,DELETE_TYPE} from '../../../configs/staticConfigs';

const initialState = {
  items: [],
  status:0,
  activity:''  
};


export default function(state = initialState, action) {
    const response = action.response; 
    switch(action.type) {
      
        // ************** APPAYRATE_LIST_AFFILIATE_SUCCESS *********************
        case types.APPAYRATE_LIST_AFFILIATE_SUCCESS:
            return {
                ...state,
                items: response.data,
                status: response.status,
                activity:LIST_TYPE
            };
        case types.APPAYRATE_LIST_AFFILIATE_ERROR:
            return {
                ...state,
                response
            };
        
        // ************** APPAYRATE_ADD_AFFILIATE_SUCCESS *********************    
        case types.APPAYRATE_ADD_AFFILIATE_SUCCESS:
            return {
                ...state,
                items: [...state.items],
                status: response.status,
                activity:ADD_TYPE,
            }
        case types.SKILL_ADD_AFFILIATE_ERROR:
            return { ...state, response };        


        // ************** APPAYRATE_UPDATE_AFFILIATE_SUCCESS *********************    
        case types.APPAYRATE_UPDATE_AFFILIATE_SUCCESS: 
            return {
                ...state,
                items:state.items.map(item => {
                    return item.id === response.data.id ? response.data : item;
                }),
                status: response.status,
                activity:UPDATE_TYPE,         
            }           
        case types.APPAYRATE_UPDATE_AFFILIATE_ERROR:
            return { ...state, response };


        // ************** APPAYRATE_DELETE_AFFILIATE_SUCCESS *********************        
        case types.APPAYRATE_DELETE_AFFILIATE_SUCCESS:
            const id = response.data.id;                
            return {
                ...state,
                items: state.items.filter(items => items.id !== id),             
                status: response.status,
                activity:DELETE_TYPE,   
            }
        case types.APPAYRATE_DELETE_AFFILIATE_ERROR:
            return { ...state, response }; 

          
        case types.CLEAR:
            return {
                ...state,
                item:{
                    id:'',
                    name: '',
                    certificateDetails:'',
                    certificateRequired:false
                },
                activity:'',
                status:0               
            }  

        default:
            return state;
    }
};